<template>
  <async-btn
    v-if="show"
    :task="task"
    icon="fa fa-times"
    label="Cancel Request"
    color="red-2"
    text-color="body"
    v-bind="$attrs"
    rounded
    no-caps
    unelevated
    @click="cancelRequest"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { ReconnectRequest } from '@/social/types';
import notify from '@/components/notify';
import { canCancel, cancelRequest } from '.';

interface Data {
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['canceled'],
  components: { AsyncBtn },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    show(): boolean {
      return canCancel(this.request);
    },
  },
  methods: {
    async cancelRequest() {
      this.task = cancelRequest(this.request);
      this.task.then(() => {
        this.$emit('canceled');
        notify('Request for new posts has been canceled.');
      });
    },
  },
});
</script>
